import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateInventory } from "../../api/inventory.api";
import { toast } from "react-toastify";
import { inventoryKeys } from "../../queryKeys";

type UpdateInventoryPayload = {
  productId: string;
  quantity: number;
};

export const useUpdateInventory = () => {

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ productId, quantity }: UpdateInventoryPayload) =>
      updateInventory(quantity, productId),

    onSuccess: (res, variables) => {
      if (res?.message?.toLowerCase() === "success") {
        toast.success("Inventory updated successfully");

        // refetch inventory
        queryClient.invalidateQueries({
          queryKey: [...inventoryKeys.all, variables.productId],
        });
      } else {
        toast.error("Failed to update inventory");
      }
    },

    onError: (error) => {
      toast.error("Failed to update inventory");
      console.error("Inventory update error:", error);
    },
  });
};
